import React from "react";

import { ButtonFeedbackProps } from "../interface";

import { Button } from "./styles";

export const ButtonFeedback: React.FC<ButtonFeedbackProps> = (props) => {

  const { textBtn, handleFeedback } = props;

  return (
    <Button type="button" onClick={() => handleFeedback(textBtn)}>
      {textBtn}
    </Button>
  );
};
